import { render, staticRenderFns } from "./PrizeSource.vue?vue&type=template&id=d5934b2e&scoped=true&"
import script from "./PrizeSource.vue?vue&type=script&lang=js&"
export * from "./PrizeSource.vue?vue&type=script&lang=js&"
import style0 from "./PrizeSource.vue?vue&type=style&index=0&id=d5934b2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5934b2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5934b2e')) {
      api.createRecord('d5934b2e', component.options)
    } else {
      api.reload('d5934b2e', component.options)
    }
    module.hot.accept("./PrizeSource.vue?vue&type=template&id=d5934b2e&scoped=true&", function () {
      api.rerender('d5934b2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/prize/lot/components/PrizeSource.vue"
export default component.exports